import { render } from "./alert-diy.vue?vue&type=template&id=34ab0b2d&scoped=true"
import script from "./alert-diy.vue?vue&type=script&lang=js"
export * from "./alert-diy.vue?vue&type=script&lang=js"

import "./alert-diy.vue?vue&type=style&index=0&id=34ab0b2d&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src4154090898/src/platform-insurance-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ab0b2d"]])

export default __exports__